import React, { Ref } from 'react';

import { Data } from '@styled-icons/boxicons-regular';
import classNames from 'classnames';
import { COLLECTION_FILTER_CURRENT_ITEM_PREFIX_COPY } from '@typedream/data';
import styles from './CurrentItemFilter.module.css';
import menuStyles from '../../Menu/Menu.module.css';

function CurrentItemFilter({
  columns,
  handleSelected,
  containerRef,
}: {
  columns: string[];
  handleSelected: (col: string) => void;
  containerRef: Ref<HTMLDivElement>
  }) {
  return (
    <div
      ref={containerRef}
      className={classNames('mb-2 mt-2 with-background-color dropdown-content', menuStyles.MenuDropdownContainer, styles.container)}
    >
      <div className={styles.optionSubtitle}>
        <Data size={16} />
        Current Item
      </div>
      {columns.map((col) => (
        <button
          onClick={() => {
            handleSelected(`${COLLECTION_FILTER_CURRENT_ITEM_PREFIX_COPY}${col}`);
          }}
          className={classNames(styles.options)}
          type="button"
          key={col}
        >
          {col}
        </button>
      ))}

    </div>
  );
}

export default React.memo(CurrentItemFilter);
